import React, { useState } from 'react';
import Select from 'react-select';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


const EventModal = ({ isOpen, setIsOpen, statusOptions, handleSubmit, couponform, image, handleChange, setCouponForm, handleThumbnailChange, preImage, setData, loading }) => {
    const url = process.env.REACT_APP_LINK

    const numberToWords = (num) => {
        if (!num) return "";

        const a = [
            "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
            "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
            "Sixteen", "Seventeen", "Eighteen", "Nineteen"
        ];
        const b = [
            "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy",
            "Eighty", "Ninety"
        ];

        const inWords = (n) => {
            if (n < 20) return a[n];
            if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
            if (n < 1000)
                return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + inWords(n % 100) : "");
            if (n < 100000)
                return (
                    inWords(Math.floor(n / 1000)) +
                    " Thousand" +
                    (n % 1000 ? " " + inWords(n % 1000) : "")
                );
            if (n < 10000000)
                return (
                    inWords(Math.floor(n / 100000)) +
                    " Lakh" +
                    (n % 100000 ? " " + inWords(n % 100000) : "")
                );
            return (
                inWords(Math.floor(n / 10000000)) +
                " Crore" +
                (n % 10000000 ? " " + inWords(n % 10000000) : "")
            );
        };

        return inWords(Number(num)) + " Rupees Only";
    };

    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" >
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Event Details</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="image" className="oms-form-label">
                            Image
                        </label>
                        <input
                            type="file"
                            id="image"
                            name='image'
                            accept="image/*"
                            // value={image}
                            onChange={handleThumbnailChange}
                        />
                        {
                            preImage ? <img style={{
                                width: "80px",
                                height: "50px"
                            }} src={`${url}/${preImage}`} alt="" /> : null
                        }

                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="title" className="oms-form-label">
                            Title
                        </label>
                        <input
                            type="text"
                            id="title"
                            name='title'
                            value={couponform.title}
                            onChange={handleChange}
                            placeholder="Enter Title"

                        />

                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="short_description" className="oms-form-label">
                            Short Description
                        </label>

                        <input
                            type="text"
                            id="short_description"
                            name="short_description"
                            value={couponform.short_description}
                            onChange={handleChange}
                            placeholder="Enter Short Description"

                        />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="join_fee" className="oms-form-label">
                            Joining Fee
                        </label>
                        <input
                            type="number"
                            id="join_fee"
                            name="join_fee"
                            value={couponform.join_fee}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (!value.includes('.') && !value.includes(',')) {
                                    handleChange(e);
                                }
                            }}
                            placeholder="Enter Joining Fee"
                            step="1"
                            min="0"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="price" className="oms-form-label">
                            Discounted Joining Fee
                        </label>
                        <input
                            type="number"
                            id="price"
                            name="price"
                            value={couponform.price}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => {
                                const value = e.target.value;
                                // Allow only whole numbers (no decimals)
                                if (!value.includes('.') && !value.includes(',')) {
                                    handleChange(e);
                                }
                            }}
                            placeholder="Discounted Joining Fee"
                            step="1" // restrict step to whole number increments
                            min="0"  // optional: prevent negatives
                        />

                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="win_amount" className="oms-form-label">
                            Winning Amount
                        </label>
                        <input
                            type="number"
                            id="win_amount"
                            name="win_amount"
                            value={couponform.win_amount}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (!value.includes('.') && !value.includes(',')) {
                                    handleChange(e);
                                }
                            }}
                            placeholder="Enter Winning Amount"
                            step="1"
                            min="0"
                        />
                        {couponform.win_amount && (
                            <p style={{ fontSize: "12px", color: "#555", marginTop: "4px" }}>
                                {numberToWords(couponform.win_amount)}
                            </p>
                        )}
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="watch_amount" className="oms-form-label">
                            Watch Time Winning Amount
                        </label>
                        <input
                            type="number"
                            id="watch_amount"
                            name="watch_amount"
                            value={couponform.watch_amount}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (!value.includes('.') && !value.includes(',')) {
                                    handleChange(e);
                                }
                            }}
                            placeholder="Enter Watch Time Winning Amount"
                            step="1"
                            min="0"
                        />
                        {couponform.watch_amount && (
                            <p style={{ fontSize: "12px", color: "#555", marginTop: "4px" }}>
                                {numberToWords(couponform.watch_amount)}
                            </p>
                        )}
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="start_time" className="oms-form-label">Start Date</label>
                        <input
                            type="date"
                            id="start_time"
                            name="start_time"
                            value={couponform.start_time || ""}
                            onChange={handleChange}
                        />
                    </div>

                    {/* End Date */}
                    <div className="oms-form-group">
                        <label htmlFor="end_time" className="oms-form-label">End Date</label>
                        <input
                            type="date"
                            id="end_time"
                            name="end_time"
                            value={couponform.end_time || ""}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="description" className="oms-form-label">
                            Event Terms
                        </label>
                        <ReactQuill
                            theme="snow"
                            value={couponform.description}
                            onChange={(value) =>
                                setData((prev) => ({ ...prev, description: value }))
                            }
                            style={{ backgroundColor: "#fefffc" }}
                            placeholder="Enter Description"
                        />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        {
                            loading ? <button type="button">Submitting...</button>
                                : <button type="submit">Submit</button>
                        }
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EventModal;
